import { render, staticRenderFns } from "./HeroHeader.vue?vue&type=template&id=3e54957c&scoped=true&"
import script from "./HeroHeader.vue?vue&type=script&lang=js&"
export * from "./HeroHeader.vue?vue&type=script&lang=js&"
import style0 from "./HeroHeader.vue?vue&type=style&index=0&id=3e54957c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54957c",
  null
  
)

export default component.exports